import React from 'react';
import SpaceRoleRangeForm from './SpaceRoleRangeForm';

function SpacesSettingCRMForm(props) {
  return <SpaceRoleRangeForm {...props} role="crm" settingKey="crm_role_setting" />;
}

export default SpacesSettingCRMForm;
